// extracted by mini-css-extract-plugin
module.exports = {"leaseInfoBlock":"LeaseInfoBlock_leaseInfoBlock__1uMGq","blockHeading":"LeaseInfoBlock_blockHeading__3-4pj","leaseDetailsSection":"LeaseInfoBlock_leaseDetailsSection__21v_L"};